import styled from 'styled-components'

const StyledCropTool = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  z-index: ${({ theme }) => theme.elevation.modal};

  .cropper {
    z-index: ${({ theme }) => theme.elevation.override};
    border-radius: 10px;
    position: fixed;
    margin: 2rem;
    top: 50%;
    left: 50%;
    outline: none;
    overflow: hidden;
    max-height: 500px;
    max-width: 500px;
    height: 100vh;
    width: 100vw;
    transform: translate(-50%, -50%);
    background-color: ${({ theme }) => theme.color.background};
    margin: 0;
    padding: 0;
    border: 0;
    display: grid;
    grid-template-rows: minmax(0, 1fr) auto;
    box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.1), 0 0 0 1px #00000019,
      0 2px 4px 0px #00000036;
  }

  .cropper-actions {
    display: flex;
    padding: 10px;
    justify-content: space-between;
  }

  .backdrop {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    transition: 0.1s;
    opacity: 1;
    background-color: #000000cc;
  }
`

export default StyledCropTool
